module.exports = __webpack_public_path__ + "img/katarina_bedrooms_15.e9c53f7c.jpg";